import React from 'react';
import { Modal, Typography } from 'antd';
import "./ConfirmationModal.scss";
import "../../App.scss";
import { getIcon } from '../../../utils/images';
import { markShipmentComplete, markShipmentCancelled } from '../../../services/shipments';

const { Text } = Typography;

const ConfirmationModalTitle = ({ handleCancel, action }) => {
  return (
    <div className='ConfirmationModal__Title'>
      <img className='close' src={getIcon('close')} onClick={handleCancel} />
      <div className='title'>
        {action === 'complete' ? 'Complete' : 'Cancel'} Shipment
      </div>
    </div>
  )
};

const ConfirmationModal = ({ shipment, isOpen, handleCancel, action = 'complete' }) => {

  function handleOk(){
    if (action === 'complete') {
      markShipmentComplete(shipment.id);
    } else if (action === 'cancel') {
      markShipmentCancelled(shipment.id);
    }
    handleCancel()
  }

  return (
    <Modal
      className='App ConfirmationModal'
      title={<ConfirmationModalTitle handleCancel={handleCancel} action={action} />}
      open={isOpen}
      onCancel={handleCancel}
      onOk={handleOk}
      closable={false}
      destroyOnClose={true}
      forceRender={true}
    >
      <Typography>
        Are you sure you want to <strong>{action}</strong> shipment <Text strong>{shipment.booking_number || shipment.bl}</Text>?
      </Typography>
    </Modal>
  );
};

export default ConfirmationModal;
